export function arrayDelete(_array, _keyDel) {
  let i = _array.indexOf(_keyDel)
  if (i >= 0) {
    _array.splice(i, 1)
    return _array
  }
  return null
}